export enum CheckoutSessionProviderMode {
    // regular mode, session will be created, restored from storage and then resynced with server
    Checkout = "checkout",

    // for thank you page to clear checkout session
    // state will be restored from storage but not synced with server and no new session will be created.
    CleanupCheckout = "cleanup-checkout",
}
